import React from "react"
import { formatPrice } from "@util/ticketUtils"
import { SmartDateFormat } from "@util/dates"
import { getNextFuturePriceChange } from "@util/concerts"

interface AlternatePricingDisplayProps {
  concert: {
    ticket_price_at_door?: number | string | null
    ticket_pricing_schedule?: unknown[]
    content_hash?: {
      ticket_price_at_door?: number | string | null
      ticket_pricing_schedule?: unknown[]
    }
  } | null
  /** Optional class for the container (e.g. "ml-1 font-normal" when inside a price block) */
  className?: string
}

export const AlternatePricingDisplay: React.FC<
  AlternatePricingDisplayProps
> = ({ concert, className = "" }) => {
  if (!concert) return null

  const nextFuturePriceChange = getNextFuturePriceChange(concert)
  const ticketPriceAtDoor =
    concert.ticket_price_at_door ??
    concert.content_hash?.ticket_price_at_door ??
    null
  const doorPrice = ticketPriceAtDoor != null && ticketPriceAtDoor !== "" ? Number(ticketPriceAtDoor) : null
  const hasDoor = doorPrice != null && doorPrice > 0

  if (!nextFuturePriceChange && !hasDoor) return null

  return (
    <div className={className}>
      {nextFuturePriceChange && (
        <div className="text-sm text-gray-600">
          <span className="text-gray-500">
            Changes to {formatPrice(nextFuturePriceChange.price_changes_to)}{" "}
            {SmartDateFormat({
              dateStr: nextFuturePriceChange.price_changes_at,
              includeTime: true,
            })}
          </span>
        </div>
      )}
      {hasDoor && (
        <div className="text-sm text-gray-600">
          <span className="text-gray-500">
            {formatPrice(doorPrice!)} at door
          </span>
        </div>
      )}
    </div>
  )
}

export default AlternatePricingDisplay
